import React, { useState } from 'react';
import BarraPersonal from './barraPersonal';
import ListaEmpleados from './listaEmpleados';
import InfoEmpleado from './InfoEmpleado';
import './Personal.css';

function Personal() {
  const [vistaActual, setVistaActual] = useState('personal');
  const [empleadoSeleccionado, setEmpleadoSeleccionado] = useState(null);
  const cambiarVista = (vista) => {
    if (vista === 'personal') {
      setEmpleadoSeleccionado(null); // al ir a personal se borra el empleado seleccionado
    }
    setVistaActual(vista);
  };
  
  

  const handleSeleccionEmpleado = (empleado) => {
    setEmpleadoSeleccionado(empleado.id_empleado);
  };

  const handleVolver = () => {
    setEmpleadoSeleccionado(null);
  };

  return (
    <div className="personal-container d-flex">
      <BarraPersonal onSeleccion={cambiarVista} />
      <div className="contenido-principal flex-grow-1">
        {vistaActual === 'personal' && (
          empleadoSeleccionado ? (
            <InfoEmpleado id_empleado={empleadoSeleccionado} onVolver={handleVolver} />
          ) : (
            <ListaEmpleados onSeleccionEmpleado={handleSeleccionEmpleado} />
          )
        )}

        {vistaActual === 'horarios' && (
          <div>
            <h3>Vista de Horarios</h3>
            {/* Aquí puedes insertar el componente de horarios más adelante */}
          </div>
        )}
      </div>
    </div>
  );
}

export default Personal;
